const storageKey = "_fnEditorBackup";
const maxEntries = 20;
const interval = 10000;
export default class FnEditorAutoSave {
    constructor(state, logger) {
        this.state = state;
        this.logger = logger;
        this.interval = null;
        this.restartInterval();
    }
    clearInterval() {
        if (this.interval) {
            clearInterval(this.interval);
        }
    }
    restartInterval() {
        this.clearInterval();
        this.interval = setInterval(() => {
            this.saveHandler();
        }, interval);
    }
    destroy() {
        this.clearInterval();
    }
    saveHandler() {
        this.logger.log('Auto saving...');
        let existingEntries = JSON.parse(localStorage.getItem(storageKey) || '[]');
        const timestamp = Date.now();
        const humanReadableDate = this.getHumanReadableDate(timestamp);
        const newEntry = {
            timestamp: timestamp,
            humanReadableDate: humanReadableDate,
            elements: this.state.elements.toRawLines(),
            selection: this.state.selection.getRaw()
        };
        existingEntries.push(newEntry);
        if (existingEntries.length > maxEntries) {
            existingEntries = existingEntries.slice(existingEntries.length - maxEntries);
        }
        localStorage.setItem(storageKey, JSON.stringify(existingEntries));
    }
    getHumanReadableDate(timestamp) {
        const date = new Date(timestamp);
        return date.toLocaleString();
    }
    getEntries() {
        const existingEntries = JSON.parse(localStorage.getItem(storageKey) || '[]');
        return existingEntries.map(entry => ({
            title: entry.humanReadableDate,
            timestamp: entry.timestamp
        })).reverse();
    }
    getEntryForRestore(timestamp) {
        this.restartInterval();
        let existingEntries = JSON.parse(localStorage.getItem(storageKey) || '[]');
        return existingEntries.find(entry => entry.timestamp === timestamp);
    }
}
